module.exports = __webpack_public_path__ + "bdacf5818089231dc667fc701ae1ba03.MP3";